import { store } from "@/store/store";
import { manychat_mensajes_log } from "@/shared/dtos/manychat_mensajes_log";
import { recordatorio_cita_log } from "@/shared/dtos/recordatorio_cita_log";
import { VuexModule, Mutation, getModule, Module, Action } from "vuex-module-decorators";
import { ssmHttpService } from "@/shared/services/http-service";
import { API } from "@/shared/api";

export interface ManychatMensajesFiltro {
  tipo_mensaje?: string | null;
  estado_envio?: string | null;
  fecha_desde?: string | null;
  fecha_hasta?: string | null;
  take?: number;
}

export interface ManychatRecordatoriosFiltro {
  tipo_recordatorio?: string | null;
  estado_envio?: string | null;
  fecha_desde?: string | null;
  fecha_hasta?: string | null;
  take?: number;
}

@Module({ namespaced: true, name: "manychatLogsModule", store, dynamic: true })
class manychatLogsModule extends VuexModule {
  public mensajes: manychat_mensajes_log[] = [];
  public recordatorios: recordatorio_cita_log[] = [];

  @Action({ commit: "onGetMensajes" })
  public async getMensajes(filtro: ManychatMensajesFiltro = {}) {
    const params: any = {};
    if (filtro.tipo_mensaje) params.tipo_mensaje = filtro.tipo_mensaje;
    if (filtro.estado_envio) params.estado_envio = filtro.estado_envio;
    if (filtro.fecha_desde) params.fecha_desde = filtro.fecha_desde;
    if (filtro.fecha_hasta) params.fecha_hasta = filtro.fecha_hasta;
    if (filtro.take) params.take = filtro.take;
    return await ssmHttpService.get(API.manychatLogs + "/mensajes", { params }, false);
  }

  @Action({ commit: "onGetRecordatorios" })
  public async getRecordatorios(filtro: ManychatRecordatoriosFiltro = {}) {
    const params: any = {};
    if (filtro.tipo_recordatorio) params.tipo_recordatorio = filtro.tipo_recordatorio;
    if (filtro.estado_envio) params.estado_envio = filtro.estado_envio;
    if (filtro.fecha_desde) params.fecha_desde = filtro.fecha_desde;
    if (filtro.fecha_hasta) params.fecha_hasta = filtro.fecha_hasta;
    if (filtro.take) params.take = filtro.take;
    return await ssmHttpService.get(API.manychatLogs + "/recordatorios", { params }, false);
  }

  @Mutation
  public onGetMensajes(res: any[]) {
    this.mensajes = res ? res.map((x) => new manychat_mensajes_log(x)) : [];
  }

  @Mutation
  public onGetRecordatorios(res: any[]) {
    this.recordatorios = res ? res.map((x) => new recordatorio_cita_log(x)) : [];
  }
}

export default getModule(manychatLogsModule);
